import { ErrCode } from './err-code.model';

/** Passed instead of a byte count when the total genuinely cannot be known in time — a folder ZIP before enumeration. */
export const STREAMING_SAVE_SIZE_UNKNOWN: unique symbol = Symbol('streamingSaveSizeUnknown');

export type StreamingSaveTotalBytes = number | typeof STREAMING_SAVE_SIZE_UNKNOWN;

export enum StreamingSaveSeam {
  SINGLE_FILE = 'singleFile',
  ZIP = 'zip',
}

export enum StreamingSaveUnavailableReason {
  FRAMED = 'framed',
  INSECURE_CONTEXT = 'insecureContext',
  API_UNAVAILABLE = 'apiUnavailable',
  REMOVE_UNAVAILABLE = 'removeUnavailable',
  BELOW_MIN_SIZE = 'belowMinSize',
  PICKER_FAILED = 'pickerFailed',
}

/** A union would read better, but boolean-discriminant narrowing needs strictNullChecks, which this project has off. */
export interface StreamingSaveCapability {
  capable: boolean;
  reason?: StreamingSaveUnavailableReason;
}

export enum StreamingSaveDestinationOutcome {
  GRANTED = 'granted',
  CANCELLED = 'cancelled',
  FAILED = 'failed',
}

export type StreamingSaveDestination =
  | { outcome: StreamingSaveDestinationOutcome.GRANTED; handle: FileSystemFileHandle }
  | { outcome: StreamingSaveDestinationOutcome.CANCELLED }
  | { outcome: StreamingSaveDestinationOutcome.FAILED; errcode: ErrCode };

export enum StreamingSaveOutcome {
  INITIATED = 'initiated',
  FELL_BACK = 'fellBack',
  PICKER_CANCELLED = 'pickerCancelled',
  COMPLETED = 'completed',
  FAILED = 'failed',
  CANCELLED = 'cancelled',
}

export interface StreamingSaveOutcomeProps {
  seam: StreamingSaveSeam;
  outcome: StreamingSaveOutcome;
  fallbackReason?: StreamingSaveUnavailableReason;
  totalSizeBytes?: number;
  fileCount?: number;
  isLink?: boolean;
  durationMs?: number;
  errorCode?: number;
}
